module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("กองผ้าป่าของฉัน")]), _vm._v(" "), (_vm.pages.length > 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pages), function(page) {
    return _c('div', {
      key: page.id,
      staticClass: "col col-lg-4 col-md-6 col-sm-6"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.pageLink(page)
      }
    }, [_c('img', {
      staticClass: "preview-image",
      attrs: {
        "src": page.image,
        "alt": "sample"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.pageLink(page)
      }
    }, [_vm._v(_vm._s(page.title))])], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pages.length === 0 && _vm.loaded) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center mb-20"
  }, [_c('p', [_vm._v("คุณยังไม่มีกองผ้าป่า")]), _vm._v(" "), (_vm.mainProductSku) ? _c('router-link', {
    staticClass: "w-50 ma-auto btn btn--purple",
    attrs: {
      "to": _vm.linkCreate()
    }
  }, [_vm._v("สร้างกองผ้าป่า")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe6fb4b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyPagePage.vue
// module id = 1182
// module chunks = 0